export const init = () => {
  const ob = new MutationObserver(() => {
    const sets = document.querySelectorAll('.s-comparison-box-set:not([data-initialized="true"])');

    if (!sets.length) return;

    sets.forEach((set, index) => {
      const tops = set.querySelectorAll('.b-comparison-box__top');
      const buttons = set.querySelectorAll('.g-btn');
      const footerInfo = set.querySelectorAll('.b-comparison-box__bottom .bottom-footer .text-wrapper');

      if (!tops.length || !buttons.length || !footerInfo.length) return;

      const runHandlers = () => {
        syncTopHeights(tops);
        syncTopHeights(buttons);
        syncTopHeights(footerInfo);
      };

      const clearHeights = () => {
        [...tops, ...buttons, ...footerInfo].forEach(el => {
          el.style.height = '';
        });
      };

      const resizeKey = `_resizeTimer_${index}`;

      const conditionalRunHandlers = () => {
        if (window.innerWidth <= 671) {
          clearHeights();
          return;
        }
        runHandlers();
      };

      if (document.readyState === 'complete') {
        conditionalRunHandlers();
      } else {
        window.addEventListener('load', conditionalRunHandlers);
      }

      window.addEventListener('resize', () => {
        clearTimeout(window[resizeKey]);
        window[resizeKey] = setTimeout(conditionalRunHandlers, 150);
      });

      // Init
      conditionalRunHandlers();
      set.setAttribute('data-initialized', 'true');
    });
  });
  ob.observe(document.body, {
    childList: true,
    subtree: true
  });
};

function syncTopHeights(elements) {
  let maxHeight = 0;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  elements.forEach(el => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  elements.forEach(el => {
    el.style.height = `${maxHeight}px`;
  });
}
